import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/**
 * `settings/Audit::ask` si `::answer`, peste `AuditAnswersController` - ce ne
 * poate spune numai clientul. Firma e a omului care raspunde, nu se trimite.
 */
export type AskOption = { value: string | number; text: string }

export type AskQuestion = {
  key: string
  question: string
  help: string
  /** `ladder` = treptele scarii de maturitate, cu cifra in fata. */
  kind: string
  options: AskOption[]
}

export type AskHave = {
  value: string
  text: string
  note: string
  at: string
  who: string
  /** Mai vechi de un an: de confirmat. */
  stale: boolean
}

export type AskCoverage = { asked: number; answered: number; stale: number }

export type AskArea = {
  area: { code: string; title: string }
  questions: AskQuestion[]
  /** Raspunsurile date, pe cheia intrebarii. */
  have: Record<string, AskHave>
  coverage: AskCoverage
}

export type AuditAsk = {
  version: string
  type: { id: number; title: string }
  areas: AskArea[]
  /** Exista `it_audit_answers` pe instanta? */
  ready: boolean
  company: number
  /** Legatura de dat omului care raspunde - intra cu contul lui. */
  link: string
}

export function auditAskQuery(type: number) {
  return queryOptions({
    queryKey: ['settings', 'audit', 'ask', type],
    queryFn: () => apiGet<AuditAsk>(`/settings/audit/ask/${type}`),
    staleTime: 30_000,
  })
}

export type AnswerSaved = { ok: true; coverage: AskCoverage } | { ok: false; error: string }

/** `Audit::answer` - un raspuns, salvat cum e dat. Un `ok: false` e un refuz spus. */
export function saveAnswer(area: string, key: string, value: string, note: string): Promise<AnswerSaved> {
  return apiPost<AnswerSaved>('/settings/audit/answer', { area, key, value, note })
}
